<template>
  <section class="flex level-1" :class="{mobile:!mobile}">   

    <!-- //TITLE MOBILE -->
      <div class="mobile" :class="{isMobile:isMobile}" v-if="mobile">
        <div class="link">
          <button class="bt btn-back" @click="goBack()">
            <font-awesome-icon :icon="['far', 'angle-left']"/>
          </button>
          <h2>Jeu concours</h2>
        </div>
        <div class="sep"></div>
      </div>
    <!-- //TITLE MOBILE -->




    <div  class="block__challengesAccueil  content__challengesAccueil"> 

      <ion-item class="refresh mobile">
        <span class="badge">
          <font-awesome-icon :icon="['far', 'sync']" />
        </span>
        <PuSkeleton :loading="isLoading" :count="1" width="180px">  
            {{general.updatedThe}} {{ maj | moment(true) }}
        </PuSkeleton>
      </ion-item>


      <!-- //TITLE DESKTOP -->
      <div class="desktop">
        <div class="header-sub">
            <div class="entete">
              <p>Jeu concours</p>
            </div>        
            
            <ion-item class="refresh">
              <span class="badge">
                <font-awesome-icon :icon="['far', 'sync']" />
              </span>
              <PuSkeleton :loading="isLoading" :count="1" width="180px">  
                {{general.updatedThe}} {{ maj | moment(true) }}
              </PuSkeleton>
          </ion-item>
        </div>
      </div>
      <!-- //TITLE DESKTOP -->


         
      <!-- //CARD ENTETE -->
      <cardChallengesHeader
        :subtitle = "'Jeu concours'"
        :startDate= cardHeader.startDate
        :endDate= cardHeader.endDate
        :title = cardHeader.name
        :targetTitle = general.targetProgress
        :ranking = "'Classement'"
        :rankingNumber = cardHeader.totalRank
        :rankingResult = cardHeader.rank
        :score = "'Score'"
        :scoreNumber = cardHeader.score
        :previousRank = cardHeader.previousRank
        :rank = cardHeader.rank
        :isLoad.sync = isLoading
        :img = theChallengeMedia
      />
      <!-- //CARD ENTETE -->



      <!-- SLIDER MOBILE -->
      <div class="block__slider mobile">
        <VueSlickCarousel v-bind="settings">
          <div  class="wrapper">
            <cardChallengesRanking
              :title = general.titleBestWeek
              :lists = cardHeader.topWeekUsers
              :isLoad.sync = isLoading
            />
          </div>

          <div  class="wrapper">
            <cardChallengesRanking
              :title = general.titleBestProgress
              :lists = cardHeader.progressUsers
              color = 'green'
              :isLoad.sync = isLoading
            />         
          </div>

          <div  class="wrapper">
            <cardChallengesRanking
              :title = general.titleBestDecrease
              :lists = cardHeader.regressUsers
              color = 'red'
              :isLoad.sync = isLoading
            />
          </div>
        </VueSlickCarousel>
      </div>
      <!-- SLIDER MOBILE -->


      <!-- SLIDER DESKTOP -->
      <b-row class="block__ranking" v-if="!isMobile">
        <b-col sm="12" lg="4">
          <cardChallengesRanking
            :title = general.titleBestWeek
            :lists = cardHeader.topWeekUsers
            :isLoad.sync = isLoading
          />
        </b-col>
        <b-col sm="12" lg="4">
          <cardChallengesRanking
            :title = general.titleBestProgress
            color = 'green'
            :lists = cardHeader.progressUsers
            :isLoad.sync = isLoading
          />
        </b-col>
        <b-col sm="12" lg="4">
          <cardChallengesRanking
            :title = general.titleBestDecrease
            color = 'red'
            :lists = cardHeader.regressUsers
            :isLoad.sync = isLoading
          />
        </b-col>
      </b-row>
      <!-- SLIDER DESKTOP -->


      <!-- BLOCK CARD DESTINATION -->
      <b-row class="block__cardDestination" v-if="isLoading || theDestination">
        <b-col sm="12">
          <cardChallengesPostCard 
            :subtitle = theDestination.name
            :desc = theDestination.resume
            :img = theDestinationMedia 
            :isLoad.sync = isLoading
          />
        </b-col>
      </b-row>
      <!-- BLOCK CARD DESTINATION -->


      <!-- //TITLE -->
      <div class="entete title" v-if="theNews.length">
        <p>{{general.contestNewsTitle}}</p>
      </div>
      <!-- //TITLE -->



      <!-- SLIDER MOBILE -->
      <div class="block__slider  blog mobile" v-if="theNews.length">
        <VueSlickCarousel v-bind="settings">
          <div class="wrapper"  v-for="(news,index) in theNews" :key="`${index}-${news.id}`">
            <cardPost 
              :title = news.title
              :desc = news.accroche
              :link = news.id
              :date = news.publishDate 
              :isLoad.sync = isLoading
            />
          </div>
        </VueSlickCarousel>
      </div>
      <!-- SLIDER MOBILE -->


      <!-- BLOCK CARD BLOG -->
      <b-row class="block__cardBlog"  v-if="theNews.length">
        <b-col sm="12" lg="4" v-for="(news,index) in theNews" :key="`${index}-${news.id}`">
          <cardPost 
            :title = news.title
            :desc = news.accroche
            :link = news.id
            :date = news.publishDate
            :isLoad.sync = isLoading
          />
        </b-col>
      </b-row>
      <!-- BLOCK CARD BLOG -->

    </div>


    <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->
      <transition name="modal">      
        <keep-alive>
          <router-view class="transition"></router-view>
        </keep-alive>
      </transition> 

    <!-- /////////////// ROUTER VIEW -> FIRST CHILD     -->



  </section>
</template>


<script>
import ParentMixin from '../../ParentMixin'
import { mapGetters } from 'vuex'
import cardChallengesHeader from '../../../module/card/CardChallengesHeader'
import cardChallengesRanking from '../../../module/card/CardChallengesRanking'
import cardChallengesPostCard from '../../../module/card/CardChallengesPostCard'
import cardPost from '../../../module/card/CardPost'
import ApiService from '../../../../services/ApiService'
import ChallengesMixin from '../challenges/ChallengesMixin'
import ApiAuthenticationService from "@/services/ApiAuthenticationService";


export default {
  name:"challengesAccueil",
    components:{
      cardChallengesHeader,
      cardChallengesRanking,
      cardChallengesPostCard,
      cardPost,
    }, 
    mixins: [
      ParentMixin,
      ChallengesMixin
    ],
    computed: {
      ...mapGetters([
        'getBrowse',
        'getGeneral',
        'getChallengeSelected',
      ])
    },
    props:{
      mobile:{
        type:Boolean,
        default:true
      }
    },
    data () {
      return {
        content:"",
        general:"",
        info:'',
        result:'',
        ranking:'',
        theChallengeMedia:'',
        theDestinationMedia:'',
        theDestination:'',
        message:'<h1>ATENTE ...</h1>',
        cardHeader:{},
        subDate:'',
        maj:'',
        theNews:[
          {},{},{}
        ],
      }
    },
    created (){
      //PASS ALL THE GENERAL TRANSLATE
      this.content = this.getBrowse;
      this.general = this.getGeneral;
      this.getData().then(() => this.isLoading = false);
  
    },
    methods : {

      async getData(){
        //GET THE DATA
        if(this.getChallengeSelected){
          let promises = [];
          promises.push(ApiService.getConcoursApi().getResume(ApiAuthenticationService.getCurrentUser().id, this.getChallengeSelected).then((data) => {
            this.cardHeader = data.data;
            this.maj = this.cardHeader.updateDate;
            this.theChallengeMedia = this.cardHeader.image ? this.cardHeader.image.id : null;
          }));
          promises.push(ApiService.getConcoursApi().getNewsList(this.getChallengeSelected).then((data) => {
            this.theNews = data.data.length ? data.data : [];
          }));
          promises.push(ApiService.getConcoursApi().getDestination(this.getChallengeSelected).then((data) => {
            this.theDestination = data.data;
            if (this.theDestination){
              if (this.theDestination.images.length > 0){
                this.theDestinationMedia = this.theDestination.images[0].id;
              }
            }
          }));
          await Promise.all(promises);
        }
      },

      //GO BACK
      goBack() {
        this.$store.dispatch('goBack')
        this.$router.push({name: "challengesHome"});  
      },

    },
    watch : {
      'getChallengeSelected' : function (){
        this.theChallengeMedia = '';
        this.theDestinationMedia = '';
        this.isLoading = true;
        this.getData().then(() => this.isLoading = false);
      },
    },  
  };
</script>
